import config from "config/config";

export const isAgentPortal = () => {
  return window.location.hostname === config.AGENT_PORTAL_HOSTNAME;
};
